import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { CLIENT_PORTAL_HOME_ROUTE } from 'src/features/client-portal/components/shell/constants';
import { useClientPortalNav } from 'src/features/client-portal/components/shell/use-client-portal-nav';
import { isClientPortalNavPathHidden } from 'src/features/client-portal/components/shell/utils';
import { useAsPath } from 'src/hooks/use-as-path';
import { isAdvisor } from 'src/utils/account';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';

export function useRedirectHiddenClientPortalRoute() {
  const auth = useAuth();
  const router = useRouter();
  const asPath = useAsPath();
  const nav = useClientPortalNav({ enabled: !isAdvisor(auth) });

  useEffect(() => {
    if (isAdvisor(auth)) {
      return;
    }
    if (nav.loading || nav.failed) {
      return;
    }
    if (!isClientPortalNavPathHidden(asPath, nav.hiddenPortalSurfaces)) {
      return;
    }
    void router.replace(CLIENT_PORTAL_HOME_ROUTE);
  }, [asPath, auth, nav.failed, nav.hiddenPortalSurfaces, nav.loading, router]);
}
